module.exports = "<div *ngIf=\"adv?.image\" class=\"add-outer-box wow fadeInLeft animated delay-4 animated\">\t\t\t\t\t\n    <div class=\"add-inner-img \"><a href=\"{{adv.link}}\" target=\"_blank\"><img src=\"{{getAdvImage(adv.image)}}\" alt=\"{{adv.title}}\"></a></div>\t\t\t\t\t\n  </div>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/forumadd/forumadd.component.html
// module id = ../../../../../src/app/home/forumadd/forumadd.component.html
// module chunks = common